import classnames from 'classnames';
import React, { PureComponent } from 'react';

import { CUSTOM_PRICING } from '../../constants/main';
import { PRICING_PROP_TYPES } from '../../constants/componentPropTypes';
import { ASSORTMENT_TAX_PROP_TYPES } from '../../constants/pricingPropTypes';

export default class Pricing extends PureComponent {
    static propTypes = {
        ...PRICING_PROP_TYPES,
        taxLabel: ASSORTMENT_TAX_PROP_TYPES,
    };

    static defaultProps = {
        fixedHeight: false,
        priceColor: 'grey-900',
        priceTextColor: 'grey-600',
    };

    render() {
        const {
            fixedHeight,
            price,
            taxLabel,
            priceDescription,
            perPaidTicketText,
            priceColor,
            priceTextColor,
        } = this.props;

        if (!priceDescription) {
            return null;
        }

        const pricingContainerClasses = classnames('eds-text-bl', {
            'marketing-text-container--fixed-height': fixedHeight,
            'eds-l-pad-vert-6': !fixedHeight,
        });

        let pricing = null;

        if (price === CUSTOM_PRICING && priceDescription === CUSTOM_PRICING) {
            pricing = <h3 className={pricingContainerClasses}>{price}</h3>;
        } else if (price === CUSTOM_PRICING) {
            pricing = (
                <h3 className={pricingContainerClasses}>
                    <span
                        className={`eds-text-color--${priceColor} eds-text-weight--heavy`}
                    >
                        {price}
                    </span>
                    <p
                        className={`eds-text-bm eds-text-color--${priceTextColor} eds-l-pad-top-1`}
                    >
                        {priceDescription}
                    </p>
                </h3>
            );
        } else if (price) {
            pricing = (
                <h3 className={pricingContainerClasses}>
                    <span
                        className={`eds-text-color--${priceColor} eds-text-weight--heavy`}
                    >
                        {price}
                    </span>
                    <div
                        className={`marketing-inline-text eds-text-bs eds-l-mar-left-1 eds-text-color--${priceTextColor}`}
                    >
                        {`${perPaidTicketText} ${taxLabel.taxDescription}`}
                    </div>
                    <p
                        className={`eds-text-bm eds-text-color--${priceTextColor} eds-l-pad-top-1`}
                    >
                        {priceDescription}
                    </p>
                </h3>
            );
        }

        return pricing;
    }
}
